import React, { useState, useEffect, Fragment } from "react";

import Signup from "./index";
import ErrorMessage from "../../components/errorMessage"
import Login from "../login";
import hexaBg from "../../img/hexa-bg.svg";
import WelcomeContainerWeb from '../signup/welcomeContainerWeb'
import WelcomeContainerMobile from "./welcomeContainerMobile";

const ContainerSignup = ({ show, handleClose, handleShow }) => {
  const [sendMail, setSendMail] = useState({
    status: false,
    value: ""
  });

  const [width, setWidth] = useState(window.innerWidth);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Fragment>

      <Login show={show} handleClose={handleClose} handleShow={handleShow} />

      <div className="form-row">

        { window.innerWidth  > 1000 ? <WelcomeContainerWeb handleShow={handleShow} /> : <WelcomeContainerMobile handleShow={handleShow} />  }        
        
        {/* left row with background image and welcome text */}

        <div className="gray-background sign-up-form-container" style={{ backgroundImage: `url(${hexaBg})` }} >
          <div className="">
            {sendMail.status ?
              <ErrorMessage message="Thank you for signing up for EncoreHive. A confirmation email has been sent to: " secondMessage="Please check your email and click the confirmation link in order to access your new account." email={sendMail.value} />
              : <Signup button={true} buttonText="Resend email" link="/" sendMail={sendMail} setSendMail={setSendMail} />}
          </div>
        </div>
        {/* right row with sig up form */}

      </div>

    </Fragment>
  );
};

export default ContainerSignup;
